<div class="main_content position-relative">
  <div class="container-fluid py-3">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow">
          <!-- Table -->
          <section>
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: selMenu == 'suggestion' }" aria-current="page" (click)="selectMenu('suggestion')">Suggestion</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: selMenu == 'report' }" (click)="selectMenu('report')">Report</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: selMenu == 'report-messages' }" (click)="selectMenu('report-messages')">Chat Message Reports</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: selMenu == 'chat-settings' }" (click)="selectMenu('chat-settings')">Chat Settings</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: selMenu == 'business-join' }" (click)="selectMenu('business-join')">Business Join Requests</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: selMenu == 'rent-product' }" (click)="selectMenu('rent-product')">Rent Product</a>
              </li>
            </ul>
            <section *ngIf="selMenu == 'chat-settings'">
              <div class="banned-words">
                <span style="font-size: 18px; font-weight: bold;">Banned Words</span>
                <div class="banner-words__list">
                  <span *ngIf="chatBadWords.length === 0">No Banned words found!</span>
                  <span *ngFor="let word of chatBadWords" class="banned-word">
                    {{ word }}
                    <button [attr.wordContent]="word" (click)="removeBannedWord($event)" class="close-btn"><i class="fa fa-x"></i></button>
                  </span>
                </div>
                <div class="w-100 d-flex">
                  <input [(ngModel)]="bannedWordToBeAdded" class="form-control" style="margin: 6px; max-width: 50%;" type="text" placeholder="Enter Banner Word" />
                  <button (click)="submitBadWord()" class="btn btn-success">Add Word</button>
                </div>
              </div>
            </section>
            <section *ngIf="selMenu == 'report-messages'">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: subMenuChat == 'unseen' }" aria-current="page" (click)="selectMenuChat('unseen')">Unresolved</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: subMenuChat == 'all' }" aria-current="page" (click)="selectMenuChat('all')">All</a>
                </li>
              </ul>
              <table class="table table-striped bg-white">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Reporter Member</th>
                    <th scope="col">Text Content</th>
                    <th scope="col">Image Content</th>
                    <th scope="col">Remark</th>
                    <th scope="col">Date</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let chatReport of activeChatReports; index as i">
                    <tr *ngIf="activeChatReports.length > 0">
                      <th scope="row">{{ chatReport.id }}</th>
                      <td>{{ chatReport.reporter.phone }}</td>
                      <td>{{ chatReport.message.textContent ?? "--" }}</td>
                      <td>
                        @if(chatReport.message.imageContent){
                        <img loading="lazy" style="width: 40px; height: 40px;" [src]="imageUrl + chatReport.message.imageContent" (click)="showImage(chatReport.message.imageContent)" />
                        }@else{
                        <span>--</span>
                        }
                      </td>
                      <td>
                        {{ chatReport.remark ?? "--" }}
                      </td>
                      <td>
                        {{ chatReport.reportTime | date : "dd/MM/yyyy" }}
                      </td>
                      <td>
                        @if(subMenuChat == 'unseen'){
                        <button
                          (click)="resolveChatReportClickHandler($event)"
                          [attr.reportId]="chatReport.id"
                          style="background-color: transparent; color: purple; border: 0px; text-decoration: underline;"
                        >
                          Mark as Resolved
                        </button>
                        }@else{
                        <span>--</span>
                        }
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="activeChatReports.length == 0">
                    <tr>
                      <td colspan="4" style="text-align: center;">No Chat Reports found</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </section>
            <section *ngIf="selMenu == 'suggestion'">
              <table class="table table-striped bg-white">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" sortable="phone">Member</th>
                    <th scope="col" sortable="level">Suggestion</th>
                    <th scope="col" sortable="status">Create Date</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let suggestion of allSuggestions; index as i">
                    <tr *ngIf="allSuggestions.length > 0">
                      <th scope="row">{{ i + 1 }}</th>
                      <td>{{ suggestion?.appUser?.phone }}</td>
                      <td>{{ suggestion?.message || 0 }}</td>
                      <td>{{ suggestion?.createdAt | date : "dd/MM/yyyy" }}</td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="allSuggestions.length == 0">
                    <tr>
                      <td colspan="4" style="text-align: center;">No Suggestions found</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </section>
            <section *ngIf="selMenu == 'report'">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" sortable="phone">Member</th>
                    <th scope="col" sortable="level">Report</th>
                    <th scope="col" sortable="level">Type</th>
                    <th scope="col" sortable="level">Category</th>
                    <th scope="col" sortable="status">Create Date</th>
                    <th scope="col" sortable="status">Detail</th>
                    <th scope="col">Image</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let report of allReports; index as i">
                    <tr *ngIf="allReports.length > 0">
                      <th scope="row">{{ i + 1 }}</th>
                      <td>{{ report?.appUser?.phone || "-" }}</td>
                      <td>{{ report?.message || 0 }}</td>
                      <td>{{ report?.type || "-" }}</td>
                      <td>{{ report?.category || "-" }}</td>
                      <td>{{ report?.createdAt | date : "dd/MM/yyyy" }}</td>
                      <td>
                        @if(['product', 'biz_product'].includes(report?.category)) {
                        <button class="btn btn-primary" (click)="viewReportDetail(report)"><i class="fa fa-eye"></i> View</button>
                        }
                      </td>
                      <td>
                        @if(report?.imageLocation){
                          <img [src]="imgUrl + report?.imageLocation" style="width: 4em;" (click)="showImage(report?.imageLocation)"/>
                        }@else{
                          <span>--</span>
                        }
                      </td>
                      <!-- <td></td> -->
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="allReports.length == 0">
                    <tr>
                      <td colspan="4" style="text-align: center;">No Reports found</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </section>

            <section *ngIf="selMenu == 'business-join'">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" sortable="phone">Type</th>
                    <th scope="col" sortable="phone">Company Name</th>
                    <th scope="col" sortable="level">Contact</th>
                    <th scope="col" sortable="level">Address</th>
                    <th scope="col" sortable="level">Postal Code</th>
                    <th scope="col" sortable="status">short Description</th>
                    <th scope="col" sortable="status">Create on</th>
                    <th scope="col" sortable="status">Action</th>
                    <!-- image_path -->
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let report of allBizReq; index as i">
                    <tr *ngIf="allReports.length > 0">
                      <th scope="row">{{ i + 1 }}</th>
                      <td>{{ report?.type }}</td>
                      <td>{{ report?.company_name || "-" }}</td>
                      <td>{{ report?.contact }}</td>
                      <td>{{ report?.address || "-" }}</td>
                      <td>{{ report?.postal_code || "-" }}</td>
                      <td>{{ report?.short_description || "-" }}</td>
                      <td>{{ report?.createdAt | date : "dd/MM/yyyy" }}</td>
                      <td>
                        <button class="btn btn-primary" *ngIf="report?.status == 'pending'" (click)="acceptBizJoinReq(report)"><i class="fa fa-eye"></i> Accept</button>
                      </td>
                      <!-- <td></td> -->
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="allReports.length == 0">
                    <tr>
                      <td colspan="4" style="text-align: center;">No Reports found</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </section>
            <section *ngIf="selMenu == 'rent-product'">
              <div><button class="btn btn-primary m-2" (click)="addProduct(addEditProduct)">Add</button></div>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" sortable="phone">Name</th>
                    <th scope="col" sortable="level">Description</th>
                    <th scope="col" sortable="level">Image</th>
                    <th scope="col" sortable="level">Created At</th>
                    <th scope="col" sortable="level">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let report of rentProduct; index as i">
                    <tr *ngIf="rentProduct.length > 0">
                      <th scope="row">{{ i + 1 }}</th>
                      <td>{{ report?.name }}</td>
                      <td>{{ report?.description || "-" }}</td>
                      <td>
                        <img loading="lazy" *ngIf="report?.image" style="    width: 100px !important;" class="map-search-listing-img mt-2 product-char-image w-100"
                        [src]="imgUrl + report?.image">
                      </td>
                      <td>{{ report?.createdAt | date:'dd/MM/YYYY'}}</td>
                      <td>
                        <button class="btn btn-primary"  (click)="edit(addEditProduct,report)"><i class="fa fa-eye"></i> Edit</button>
                        <button class="btn btn-primary ml-2"  (click)="removeRentProduct(report?.id)"><i class="fa fa-trash"></i> Remove</button>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="allReports.length == 0">
                    <tr>
                      <td colspan="4" style="text-align: center;">No Reports found</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </section>
          </section>
          <!-- Table -->
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addEditProduct let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add/edit</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <img loading="lazy" *ngIf="imageBase64" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64" alt="" />
      <img loading="lazy" *ngIf="selectedCategory?.image" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + selectedCategory?.image" />

      <button class="com_btn px-1 month-list-add-more mt-3" (click)="upload.click()"><i class="fas fa-plus"></i> Upload Image</button>
      <input type="file" #upload (change)="saveProductCharSelectedImage($event)" class="suggestion-modal-pic-input d-none" accept="image/*" />

      <div class="row">
        <div class="form-group col-12">
          <label for="exampleInputEmail1">Title</label>
          <div class="d-flex">
            <input type="radio" name="option" class="mr-2" formControlName="type" placeholder="Enter your company name" value="rent" /> Rent
            <input type="radio" name="option" class="ml-2 mr-2" formControlName="type" placeholder="Enter your company name" value="shop" /> Shop
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="exampleInputEmail1">Title</label>
          <input type="text" formControlName="name" class="form-control" placeholder="Enter Title" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label for="exampleInputEmail1">Price</label>
          <input type="number" formControlName="price" class="form-control" placeholder="Enter price" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label for="exampleInputEmail1">Description</label>
          <input type="text" formControlName="description" class="form-control" placeholder="Enter Description" />
        </div>
      </div>
      <duv class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="AddEditCategorySubmit()">
          Save
        </button>
      </duv>
    </form>
  </div>
</ng-template>
